import React from 'react';
import LoginPage from '../Pages/LoginPage';
import AppRoute, { LayoutType } from './models/AppRoute';
import { AdminLayout, ClassicLayout, LoginLayout } from '../components/Layout';
import LogoutPage from '../Pages/LogoutPage';
import HomePage from '../Pages/HomePage';
import UpdateUserProfilePage from '../Pages/UserProfilePage';
import ArrivalSchedulePage from '../Pages/ArrivalSchedulePage';
import EmailConfirmationPage from '../Pages/RegistrationPage/EmailConfirmationPage';

import RegistrationWizardPage from '../Pages/RegistrationWizardPage';
import TransactionHistoryPage from 'Pages/TransactionHistoryPage';
import ForgetPasswordPage from '../Pages/ForgetPasswordPage';
import StrippingSchedulePage from 'Pages/Schedule/StrippingSchedulePage';
import CargoChargesPage from 'Pages/CargoChargesPage';
import ForgetPasswordCompleteForm from 'components/UserManagement/ForgetPassword/ForgetPasswordCompleteForm';
import { Operations } from './Api/Kopp/Api';
import ResendEmailConfirmationPage from 'Pages/ResendEmailConfirmationPage';
import UserProfileTabbed from 'components/UserManagement/Profile/UserProfileTabbed';
import CartOverviewPage from 'Pages/CartOverviewPage';
import CheckoutPage from 'Pages/CheckoutPage';
import ResetPassword from './../components/UserManagement/ForgetPassword/ResetPassword/ResetPassword';
import { Layout } from 'antd';
import NotFoundPage from '../Pages/NotFoundPage';
import BlankCenteredLogoLayout from 'components/Layout/BlankCenteredLogoLayout';
import BlankLeftLogoLayout from 'components/Layout/BlankLeftLogoLayout';
import PaymentProcessingPage from 'Pages/PaymentProcessingPage';
import CheckoutConfirmationPage from 'Pages/CheckoutConfirmationPage';
import ThreeDSecurePage from 'Pages/ThreeDSecurePage';
import GeneralPaymentErrrorPage from 'Pages/GeneralPaymentErrrorPage';
import PrivacyPolicyPage from 'Pages/PrivacyPolicyPage';
import TermsAndConditionsPage from 'Pages/TermsAndConditionsPage';
import EmptyLayout from 'components/Layout/EmptyLayout';
import TrackedBolDetailViewPage from 'Pages/TrackedBolDetailViewPage';
import TrackedBolSearchFormPage from 'Pages/TrackedBolSearchFormPage';
import TrackedBolOverviewPage from 'Pages/TrackedBolOverviewPage';
import CustomerBolPage from 'Pages/CustomerBolPage';
import { CustomerBolDetail } from 'components/CustomerBolOverview';
import CustomerBolDetailPage from 'Pages/CustomerBolDetailPage';

export const AppRoutes: AppRoute[] = [
  {
    title: 'Home',
    redirect: 'home',
    path: '/',
    exact: true,
    layout: (props: any) => <ClassicLayout {...props} />,
    icon: 'star',
    skip: true,
    routes: [
      {
        title: 'Home',
        icon: 'home',
        path: 'home',
        exact: true,
        component: HomePage,
      },
      {
        title: 'Email Registration Confirmation',
        icon: 'email',
        layout: (props: any) => <BlankCenteredLogoLayout {...props} />,
        path: 'emailconfirmation',
        hideInMainMenu: true,
        component: EmailConfirmationPage,
      },
      {
        title: 'Resend Email Registration Confirmation Token',
        icon: 'email',
        layout: (props: any) => <BlankCenteredLogoLayout {...props} />,
        path: 'resend-emailconfirmation',
        hideInMainMenu: true,
        component: ResendEmailConfirmationPage,
      },
      {
        title: 'Get & Pay Charges',
        icon: 'dollar',
        layout: (props: any) => <ClassicLayout {...props} />,
        path: 'charges',
        component: CargoChargesPage,
        requiredOperations: [Operations.Is_Autenticated],
        routes: [

        ]
      },
      {
        title: 'Customer Bols',
        path: 'customer-bol',
        icon: 'dollar',
        component: CustomerBolPage,
        requiredOperations: [Operations.Is_Autenticated],
        hideInMainMenu: false,
        routes: [
          {
            title: 'Customer Bol Charges',
            path: 'detail',
            component: CustomerBolDetailPage,
            requiredOperations: [Operations.Is_Autenticated],
            hideInMainMenu: true,
          },
        ]
      },
      {
        title: 'Click N Collect',
        icon: 'home',
        path: 'click-n-go',
        hideInMainMenu: false,
        requiredOperations: [Operations.Is_Autenticated],
        layout: (props: any) => <ClassicLayout {...props} />,
        component: TrackedBolOverviewPage,
        routes: [
          {
            title: 'Click N Collect Detail',
            icon: 'dollar',
            hideInMainMenu: true,
            requiredOperations: [Operations.Is_Autenticated],
            layout: (props: any) => <ClassicLayout {...props} />,
            path: 'detail',
            component: TrackedBolDetailViewPage,
          },
          {
            title: 'Register Click N Collect BL',
            icon: 'home',
            hideInMainMenu: true,
            requiredOperations: [Operations.Is_Autenticated],
            path: 'register',
            component: TrackedBolSearchFormPage,
          }
        ]
      },
      {
        title: 'Container Schedule',
        icon: 'schedule',
        layout: (props: any) => <ClassicLayout {...props} />,
        path: 'container-schedule',
        // strict: true,
        component: StrippingSchedulePage,
      },
      {
        title: 'Vessel Schedule',
        icon: 'schedule',
        layout: (props: any) => <ClassicLayout {...props} />,
        path: 'vessel-schedule',
        component: ArrivalSchedulePage,
      },
      {
        title: 'Cart',
        icon: 'cart',
        layout: (props: any) => <ClassicLayout {...props} />,
        path: 'cart',
        component: CartOverviewPage,
        hideInMainMenu: true,
        requiredOperations: [Operations.Is_Autenticated],
      },
      {
        title: 'Contact Us',
        icon: 'phone',
        layout: (props: any) => <ClassicLayout {...props} />,
        hideInMainMenu: true,
        path: 'contact-us',
        component: () => <h1> Contact Us</h1>,
      },
      {
        title: 'Sign Up',
        icon: 'user-add',
        hideInMainMenu: true,
        layout: (props: any) => <ClassicLayout {...props} />,
        path: 'sign-up',
        component: RegistrationWizardPage,
      },
      {
        title: 'View Transactions History',
        icon: 'history',
        hideInMainMenu: false,
        requiredOperations: [Operations.Is_Autenticated],
        layout: (props: any) => <ClassicLayout {...props} />,
        path: 'transaction-history',
        component: TransactionHistoryPage,
      },
      {
        title: 'Checkout page',
        icon: 'user-add',
        hideInMainMenu: true,
        layout: (props: any) => <ClassicLayout {...props} />,
        path: 'checkout',
        requiredOperations: [Operations.Is_Autenticated],
        component: CheckoutPage,
      },
      {
        title: 'Processing Payment...',
        icon: 'user-add',
        hideInMainMenu: true,
        layout: (props: any) => <BlankLeftLogoLayout {...props} />,
        path: 'payment-processing',
        requiredOperations: [Operations.Is_Autenticated],
        component: PaymentProcessingPage,
      },
      {
        title: 'Processing Payment...',
        icon: 'user-add',
        hideInMainMenu: true,
        layout: (props: any) => <BlankLeftLogoLayout {...props} />,
        path: '3d-secure',
        component: ThreeDSecurePage,
      },
      {
        title: 'Checkout Confirmation',
        hideInMainMenu: true,
        layout: (props: any) => <ClassicLayout {...props} />,
        path: 'payment-complete',
        requiredOperations: [Operations.Is_Autenticated],
        component: CheckoutConfirmationPage,
      },
      {
        title: 'Payment Error',
        hideInMainMenu: true,
        layout: (props: any) => <ClassicLayout {...props} />,
        path: 'payment-error',
        requiredOperations: [Operations.Is_Autenticated],
        component: GeneralPaymentErrrorPage,
      },
      {
        title: 'Forget Password',
        icon: 'question',
        hideInMainMenu: true,
        layout: (props: any) => <BlankCenteredLogoLayout {...props} />,
        path: 'forget-password',
        component: ForgetPasswordPage,
      },
      {
        title: 'Forget Password Confirmation',
        icon: 'question',
        hideInMainMenu: true,
        layout: (props: any) => <BlankCenteredLogoLayout {...props} />,
        path: 'forget-password-complete',
        component: ForgetPasswordCompleteForm,
      },
      {
        title: 'User Profile',
        path: 'user-profile',
        icon: 'folder',
        hideInMainMenu: true,
        layout: (props: any) => <ClassicLayout {...props} />,
        exact: true,
        requiredOperations: [Operations.Is_Autenticated],
        component: UserProfileTabbed,
        routes: [
          {
            title: 'Account Information',
            path: 'account-info',
            component: UserProfileTabbed,
            requiredOperations: [Operations.Is_Autenticated],
            hideInMainMenu: true,
          },
          {
            title: 'Reset Password',
            path: 'reset-password',
            component: UserProfileTabbed,
            requiredOperations: [Operations.Is_Autenticated],
            hideInMainMenu: true,
          },
          {
            title: 'Register Credit Card',
            path: 'register-card',
            component: UserProfileTabbed,
            requiredOperations: [Operations.Is_Autenticated],
            hideInMainMenu: true,
          },

        ],
      },
      {
        title: 'Logout',
        path: '/logout',
        icon: 'user',
        exact: true,
        hideInMainMenu: true,
        layout: (props: any) => <LoginLayout {...props} />,
        component: LogoutPage,
      },
      {
        title: 'Privacy Policy',
        path: '/privacy-policy',
        icon: 'user',
        exact: true,
        hideInMainMenu: true,
        component: PrivacyPolicyPage,
      },
      {
        title: 'Terms and Conditions',
        path: '/terms',
        icon: 'user',
        exact: true,
        hideInMainMenu: true,
        component: TermsAndConditionsPage,
      },
      {
        title: 'Login',
        path: '/login',
        icon: 'up',
        hideInMainMenu: true,
        layout: (props: any) => <LoginLayout {...props} />,
        component: LoginPage,
      },
    ],
  },
  {
    title: '404',
    path: '/*',
    hideInMainMenu: true,
    layout: (props: any) => <EmptyLayout {...props} />,
    component: NotFoundPage,
  },
];
